<script setup lang="ts">
import type { Snackbar } from "@/utils/useSnackbar"
import { KButton, KSnackbar } from "@kaleidoscope-solutions/ks-design-system"
import { useSnackbar } from "@/utils/useSnackbar"

const { hasSnacks, snacks, removeSnackbar } = useSnackbar()
</script>

<template>
  <div
    v-if="hasSnacks"
    class="pointer-events-none fixed inset-0 z-100 flex flex-col items-center space-y-4 p-4"
    data-test="alert-container"
  >
    <TransitionGroup
      enter-active-class="duration-300 ease-out"
      enter-from-class="transform opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="duration-200 ease-in"
      leave-from-class="opacity-100"
      leave-to-class="transform opacity-0"
    >
      <div
        v-for="a in snacks"
        :key="a.message"
      >
        <KSnackbar
          message=""
          :type="a.type"
        >
          <span class="min-w-0 wrap-break-word whitespace-pre-line">{{ a.message }}</span>
          <template v-if="a.actions">
            <div class="pointer-events-auto ms-4 flex items-center gap-2">
              <KButton
                v-for="action in a.actions"
                :key="action.label"
                variety="tertiary"
                color="violet"
                size="small"
                class="items-center"
                @click="() => { action.action?.(); removeSnackbar(a as Snackbar) }"
              >
                {{ action.label }}
              </KButton>
            </div>
          </template>
        </KSnackbar>
      </div>
    </TransitionGroup>
  </div>
</template>
